import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import CourseComponent from "../../../components/CourseComponent";
import image1 from "../../../../../../../shared/resources/batmanlogo.jpg";
import PageHeader from "../../../../../components/page-header/PageHeader";
import { useWorkshops } from "../../../../../../../contexts/workshops-context/WorkshopsContext";
import { useAppUser } from "../../../../../../../contexts/user-context/UserContext";
import SelectCountry from "../../../../../../../shared/components/countrySelectorModal/SelectCountry";
import "./styles.scss";
import { useHistory } from "react-router-dom";
import { DashboardLibraryPages } from "../../LibraryRoutes";
import { HiOutlineClipboardCopy } from "react-icons/hi";
import WorkshopCopyModel from "../../../components/workshop-copy-model/WorkshopCopyModel";

const Workshops = () => {
  const workshopsContext  = useWorkshops();
  const appUser = useAppUser();
  const history = useHistory();
  const {
    country,
    workshops,
    loading,
    mainLoading,
    setShowCopyModel,
    setLoading,
    showModel,
    setShowModel,
    showCompyModel,
  } = workshopsContext ;

  return (
    <>
      <PageHeader showButton title="Workshops" />
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
        }}
      >
        <Row>
          {country !== "DEFAULT" && workshops.length === 0 && !mainLoading && (
            <Col
              className="text-center"
              style={{
                marginTop: "100px",
                color: "grey",
              }}
            >
              <h4>There are no workshops created for this country yet.</h4>
              {(appUser.userRole.isAdmin || appUser.userRole.isModerator) && (
                <>
                  <h4>
                    Click "Create New Workshop" button to add a new workshop
                  </h4>
                  <button
                    style={{
                      marginRight: "0px",
                      marginTop: "30px",
                      color: "black",
                    }}
                    onClick={() =>
                      history.push(DashboardLibraryPages.CREATE_NEW_WORKSHOP)
                    }
                    className="body-create-workshop-button pr-4"
                  >
                    Create New Workshop
                  </button>
                  {appUser.userRole.isAdmin && (
                    <>
                      <h3 className="mt-5">- or -</h3>
                      <div
                        className="text-right mt-4"
                        style={{
                          color: "#959090",
                          fontWeight: "bold",
                          fontSize: "20px",
                          display: "flex",
                          alignContent: "center",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        Copy content from
                        <span style={{ fontSize: "30px" }}>
                          <HiOutlineClipboardCopy
                            onClick={() => setShowCopyModel(true)}
                            style={{
                              transform: "scaleX(-1.5) scaleY(1.5)",
                              color: "#006699",
                              cursor: "pointer",
                              marginLeft: "20px",
                            }}
                          />
                        </span>
                      </div>
                    </>
                  )}
                </>
              )}
            </Col>
          )}
          <Col xs={12}></Col>
          {workshops.map((wk, index) => {
            return (
              <Col
                xs={12}
                sm={12}
                md={6}
                lg={4}
                className="py-2 pl-0 pr-0"
                key={index}
              >
                <CourseComponent
                  index={index}
                  id={wk.id}
                  title={wk.title}
                  description={wk.description}
                  imageURL={image1}
                  loading={loading}
                  onActionStart={() => setLoading(true)}
                  onActionFinished={() => setLoading(false)}
                  orderNo={wk.orderNo}
                  thumbnail={wk.thumbnail}
                />
              </Col>
            );
          })}
        </Row>
        {appUser.userRole.isAdmin && (
          <Row>
            <SelectCountry
              show={showModel}
              onHide={() => {
                setShowModel(false);
              }}
            />
          </Row>
        )}
      </Container>
      <WorkshopCopyModel
        show={showCompyModel}
        onHide={() => setShowCopyModel(false)}
        activeList={{
          curriculum: false,
          libraryHome: false,
          workshopContent: true,
        }}
      />
    </>
  );
};

export default Workshops;
